import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { LocomotiveScrollProvider, useLocomotiveScroll } from 'react-locomotive-scroll';
import VimeoPlayer from '@vimeo/player';
import iconTwitter from '../img/icon-twitter.svg';
import iconTwitterBrown from '../img/home/icon-twitter.svg';
import iconOpenSea from '../img/home/icon-opensea.svg';
import iconDiscord from '../img/home/icon-discord.svg';
import iconInstagram from '../img/home/icon-instagram.svg';
import play from '../img/home/play.svg';
import arrow from '../img/home/arrow.svg';
import loading from '../img/loading.svg';
import error from '../img/error.svg';
import check from '../img/check.svg';
import apePic1 from '../img/home/ape-1.png';
import apePic2 from '../img/home/ape-2.png';
import apePic3 from '../img/home/ape-3.png';
import apePic4 from '../img/home/ape-4.png';
import apePic5 from '../img/home/ape-5.png';
import apePic6 from '../img/home/ape-6.png';
import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss';
import 'pure-react-carousel/dist/react-carousel.es.css';
import road1 from '../img/home/roadmap_1.png';
import road2 from '../img/home/roadmap_2.png';
import road3 from '../img/home/roadmap_3.png';
import road4 from '../img/home/roadmap_4.png';
import rise from '../img/rise.png';
import authorape from '../img/home/authorape.png';
import comingsoon from '../img/home/comingsoon.png';
import banana from '../img/home/banana.png';
import book from '../img/home/book.png';
import caseimg from '../img/home/case.png';
import herb from '../img/home/herb-ape.png';
import forevimg from '../img/home/foreverapes.png';
import Rise from "./Rise"

function Home(props){

    //Video Toggle
    const [ video , setVideo ] = React.useState(false);

    //The Quantity
    const [ quantity , setQuantity ] = React.useState(1);

    //Get the Locomotive Scroll Data
    const { scroll }  = useLocomotiveScroll();

    //Temporary Redirect
    console.log('???');
    window.location.href = '/cards';

    /**
    *
    *
    *
    *
    **/
    React.useEffect(() => {
        if( scroll ){

            var triggered = false;

            //
            scroll.on('scroll',(el)=>{

                if( !triggered ){
                
                    triggered = true;
                
                    window.dispatchEvent(new Event('resize'));
                
                }

            });


        }
    }, [ scroll ]);




    /**
    *
    *   goTo
    *       - Manages the Scroll in Locomotive
    *
    *   Params:
    *       el          - (Element) The Element to interact with
    *       location:   - (Hash) The Hash URL to go to
    * 
    **/
    function goTo( el , location ){
        if( scroll ){

            scroll.scrollTo( location );

        }else{
            
            //Default Behaviour
            el.scrollIntoView({ behavior: 'smooth' });

        }
    }



    /**
    *
    *   render
    *       - Render the App
    *
    **/
    return (
        <div>

            <section className="header-home">
                <div className="header-home__bg-video-wrp">
                    <div className="overlay"></div>
                    <iframe className="header-home__bg-video" data-scroll data-animate="fadeIn" src="https://player.vimeo.com/video/646533280?background=1" frameBorder="0" allow="autoplay; fullscreen"></iframe>
                </div>
                <div className="container-np">
                    <div className="header-home__wrp">
                        
                        <ModalVideo

                            channel="vimeo"
                            autoplay="true"
                            isOpen={ video }
                            videoId="646616789"
                            onClose={ (e) => {

                                setVideo( !video ); 
                            
                                var videos = document.querySelectorAll('iframe[src*="vimeo"]')

                                videos.forEach((el) => {

                                    let Player = new VimeoPlayer(el);

                                    Player.play();

                                })

                            } }
                            maxheight="1024"
                            maxwidth="400"
                            autopause="false"
                        />

                        {/* <!-- Title & Play --> */}
                        <div className="header-home__title-play-wrp">
                            <h1 className="header-home__title" data-scroll data-animate="fadeIn,moveUp">
                                <span data-scroll data-animate="fadeIn" style={{ 'animationDelay': '1.5s' }} className="font2">Welcome </span>
                                <span data-scroll data-animate="fadeIn" style={{ 'animationDelay': '2s' }}>to </span> 
                                <span data-scroll data-animate="fadeIn" style={{ 'animationDelay': '2.5s' }}>the </span> 
                                <span data-scroll data-animate="fadeIn" style={{ 'animationDelay': '3s' }}>Jungle.</span>
                            </h1>

                            <div data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '4.5s' }}>
                                <a className="header-home__play" id="playVideo" href="#" onClick={ ()=> setVideo( !video ) }>
                                    <span className="circle"></span>
                                    <img src={arrow} alt="Play" />
                                </a>
                            </div>
                        </div>
                        {/* <!-- END Title & Play --> */}
                    </div>
                </div>
            </section>
            <section className="details">
                <div className="container-np">
                    <div className="header-details__wrp">
                        <div className="header-details__btn-container">
                            <a className="header-details__btn-down" onClick={(el) => goTo(el , '#confidential') } data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '4.5s' }}>Learn More</a>
                        </div>
                    </div>
                </div>
                <div className="container-np">
                        {/* <!-- END Title & Play -->

                    <div className="header-details__wrp-col">

                        {/* <!-- IMG -->
                        <div className="header-details__img-wrp">
                            <iframe src="https://player.vimeo.com/video/666954232?background=1" frameBorder="0" allow="autoplay; fullscreen" width="100%" data-scroll data-scroll-direction="vertical" data-scroll-speed="2"></iframe>
                        </div>
                        {/* <!-- END IMG -->

                        {/* <!-- Texts & Btns -->
                        <div className="header-details__texts-btns" data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.5s' }}>

                            {/* <!-- Text & Title -->
                            <img src={rise} alt="genesis" id="rise" className="header-details__uppercase-img">

                            </img>
                                <p className="header-details__text">Rise is the exclusive NFT for the Forever Apes community. With only 5000 available, each is redeemable for a coffee table book. But that's not all! Rise NFTs will come in a variety of unique rarities that will be reflected in your IRL book.</p>
                             <Rise {...props} />
                                {/* 
                                <!-- END ACTIONS -->
                                <!-- Author Ape --> 

                                <a href="https://genesis.foreverapes.io" className="header-details__author-ape">
                                    <img className="header-details__author-ape-img" src={authorape} alt="Feather and oiler"></img>
                                    <p className="header-details__author-ape-text">AUTHOR? CLICK HERE TO REDEEM GENESIS TOKEN.</p>
                                </a>
                                {/* <!-- END Author Ape -->

                        </div>
                        {/* <!-- END Texts & Btns -->

                    </div>
                        */}
                </div>
            </section>

            {/* <!-- Confidential --> */}
            <section id="confidential" className="confidential">
                <div className="container-np">
                    <div className="confidential__wrp">

                        {/* <!-- Title --> */}
                        <h2 className="confidential__title-text" data-scroll data-scroll-direction="vertical" data-animate="fadeIn,moveUp" style={{ 'animationDelay': '0.25s' }}>
                            <span className="brown font2">Forever Apes</span> commemorates the <span className="font2">stories, experiences</span> & <span className="font2">art</span> from the BAYC community, within a luxury coffee table book.
                        </h2>
                        {/* <!-- END Title -->

                        <!-- Texts --> */}
                        <div className="confidential__text-wrp">
                            <h2 className="confidential__title" data-scroll data-scroll-direction="vertical" data-scroll-speed="1"><span>The</span> Rarity</h2>
                            <div className="confidential__text-rotate-wrp" data-scroll data-scroll-direction="horizontal" data-scroll-speed="4">
                                <p className="confidential__text-rotate">
                                    CONFIDENTIAL
                                </p>
                            </div>
                            <div className="confidential__img-wrp">
                                <img className="confidential__img-text" src={comingsoon} alt="Coming Soon" data-scroll data-scroll-direction="vertical" data-scroll-speed="1"></img>
                                <img className="confidential__img-banana" src={banana} alt="Banana" data-scroll data-scroll-direction="vertical" data-scroll-speed="2"></img>
                            </div>
                        </div>
                        {/* <!-- END Texts --> */}

                    </div>
                </div>
            </section>
            {/* <!-- END Confidential --> */}

            {/* <!-- Featured Story --> */}
            <section className="featured-story">

                {/* <!-- IMG --> */}
                <div  className="featured-story__img-wrp">
                    <div className="featured-story__img" data-scroll data-scroll-direction="vertical" data-scroll-speed="0" data-scroll-delay="1" style={{ transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)' }}>
                        <img src={book} alt="Book" data-scroll data-scroll-direction="horizontal" data-scroll-speed="2" data-scroll-delay="1" style={{ transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 10.3337, 0, 0, 1)' }} />
                    </div>
                    <div className="featured-story__img-case" data-scroll data-scroll-direction="vertical" data-scroll-speed="1" data-scroll-delay="1" style={{ transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0.130936, 0, 1)' }}>
                        <img src={caseimg} alt="Case" data-scroll data-scroll-direction="horizontal" data-scroll-speed="-2" data-scroll-delay="1" style={{ transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.308057, 0, 0, 1)' }} />
                    </div>
                </div>
                {/* <!-- END IMG --> */}

                <div className="container-np">
                    <div className="featured-story__wrp">

                        {/* <!-- Feedback --> */}
                        <div className="featured-story__feedback">

                            {/* <!-- IMG --> */}
                            <div className="featured-story__feedback-img-wrp">
                                <img src={herb} alt="Herb Ape" className="featured-story__feedback-img" data-scroll data-scroll-direction="vertical" data-scroll-speed="0.5" data-scroll-delay="1" />
                            </div>
                            {/* <!-- END IMG -->

                            <!-- Text --> */}
                            <div className="featured-story__text-wrp">
                                <p className="featured-story__text">
                                    <span data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.25s' }}>
                                    My <span className="font2">Ape</span> is the <span className="font2">greatest</span> piece of digital artwork that will ever exist from this era
                                    </span>
                                    <span className="name"  data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.5s' }}>Herb</span>
                                </p>
                            </div>
                            {/* <!-- END Text --> */}

                        </div>
                        {/* <!-- END Feedback -->

                        <!-- Stories --> */}
                        <div className="featured-story__stories">

                            {/* <!-- Text --> */}
                            <div className="featured-story__stories-text-wrp"  data-scroll data-scroll-direction="vertical" data-scroll-speed="-1">
                                <p className="featured-story__stories-text-1" data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.5s' }}>STO-</p>
                                <div className="featured-story__stories-img-wrp" data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.25' }}>
                                    <img src={forevimg} alt="Forever Apes" className="featured-story__stories-img" />
                                </div>
                                <p className="featured-story__stories-text-2" data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '0.75s' }}>RIES</p>
                                <div className="featured-story__stories-btn-wrp" data-scroll data-animate="fadeIn,moveUp" style={{ animationDelay: '1s' }}>
                                    <ReactTooltip id="toolTipStories" />
                                    <a href="https://stories.foreverapes.io" data-for="toolTipStories" className="btn-brown-border">READ STORIES</a>
                                </div>
                            </div>
                            {/* <!-- END Text --> */}

                        </div>
                        {/* <!-- END Stories --> */}

                    </div>
                </div>
            </section>
            {/* <!-- END Featured Story --> */}
                   
            {/* <!-- Road Map --> */}
            <section id="roadmap" className="roadmap">
                <div className="container-np">
                    <div className="roadmap__wrp">

                        {/* <!-- Title --> */}

                        <h2 className="roadmap__title" data-scroll data-animate="fadeIn,moveUp"><span>Table</span> of Contents</h2>
                        {/* <!-- Title -->

                    <!-- Phase 1 --> */}
                        {/* <!-- Phase 1 --> */}
                        <div className="roadmap__phase icon">

                            {/* <!-- IMG --> */}
                            <div className="roadmap__phase-img-wrp">
                                <div className="roadmap__wrp-img roadmap__wrp-img_1" style={{ background: '#191919' }}>
                                    <img style={{ "maxWidth": "200px" }} src={road1} alt="RoadMap" data-scroll data-animate="fadeIn,moveUp" />
                                </div>
                            </div>
                            {/* <!-- END IMG --> */}

                            {/* <!-- Text & Title --> */}
                            <div className="roadmap__phase-texts">
                                <p className="roadmap__phase-top" data-scroll data-animate="fadeIn,moveUp">
                                    CHAPTER I
                                </p>
                                <h3 className="roadmap__phase-title" data-scroll data-animate="fadeIn,moveUp" style={{ textDecoration: 'line-through', color: '#535353' }}>
                                    Story Submission
                                </h3>
                                <p className="roadmap__phase-text" data-scroll data-animate="fadeIn,moveUp">
                                    150 BAYC OGs submit their story and experiences with their Forever Ape - stories of them aping in, and how life changed since then - bring tissues.
                                    <br />
                                    Each Forever Ape also gets a full page portrait in the book - suits optional.
                                </p>
                            </div>
                            {/* <!-- END Text & Title --> */}

                        </div>
                        {/* <!-- END Phase 1 -->

                <!-- Phase 2 -->
                        <div className="roadmap__phase">

                            {/* <!-- IMG -->
                            <div className="roadmap__phase-img-wrp">
                                <div className="roadmap__wrp-img roadmap__wrp-img_2">
                                    <img style={{ "maxWidth": "227px" }} src={road2} alt="RoadMap" data-scroll data-animate="fadeIn,moveUp" />
                                </div>
                            </div>
                            {/* <!-- END IMG -->

                            {/* <!-- Text & Title -->
                            <div className="roadmap__phase-texts">
                                <p className="roadmap__phase-top" data-scroll data-animate="fadeIn,moveUp">
                                    CHAPTER II
                                </p>
                                <h3 className="roadmap__phase-title" data-scroll data-animate="fadeIn,moveUp">
                                    The Genesis &amp; Rise Mint
                                </h3>
                                <p className="roadmap__phase-text" data-scroll data-animate="fadeIn,moveUp">
                                    Mint the exclusive Rise NFT for 0.07 eth to redeem a coffee table book at cost. But that's not all! Not all books are created equal, and the 5000 Rise NFTs will have a selection of unique (and familiar) rarities. Each book will also include serials based on your token ID. The When and The What - both matter!
                                    <br />
                                    The 150 story contributors mint their Genesis NFTs, used to redeem a Forever Apes coffee table book for 🆓.
                                </p>
                            </div>
                            {/* <!-- END Text & Title -->

                        </div>
                        {/* <!-- END Phase 2 -->

                <!-- Phase 3 --> */}
                        <div className="roadmap__phase">

                            {/* <!-- IMG --> */}
                            <div className="roadmap__phase-img-wrp roadmap__wrp-img_3">
                                <div className="roadmap__wrp-img">
                                    <img style={{ "maxWidth": "206px" }} src={road3} alt="RoadMap" data-scroll data-animate="fadeIn,moveUp" />
                                </div>
                            </div>
                            {/* <!-- END IMG --> */}

                            {/* <!-- Text & Title --> */}
                            <div className="roadmap__phase-texts">
                                <p className="roadmap__phase-top" data-scroll data-animate="fadeIn,moveUp">
                                    CHAPTER II
                                </p>
                                <h3 className="roadmap__phase-title" data-scroll data-animate="fadeIn,moveUp">
                                    The Redemption
                                </h3>
                                <p className="roadmap__phase-text" data-scroll data-animate="fadeIn,moveUp">
                                    Want a coffee table book? Hold on tight to your $APE. Book redemption will begin SOON available only in Ape Coin.
                                </p>
                            </div>
                            {/* <!-- END Text & Title --> */}

                        </div>
                        {/* <!-- END Phase 3 -->

                <!-- Phase 4 --> */}
                        <div className="roadmap__phase">

                            {/* <!-- IMG --> */}
                            <div className="roadmap__phase-img-wrp roadmap__wrp-img_4">
                                <div className="roadmap__wrp-img">
                                    <img style={{ "maxWidth": "131px" }} src={road4} alt="RoadMap" data-scroll data-animate="fadeIn,moveUp" />
                                </div>
                            </div>
                            {/* <!-- END IMG -->

                    <!-- Text & Title --> */}
                            <div className="roadmap__phase-texts">
                                <p className="roadmap__phase-top"  data-scroll data-animate="fadeIn,moveUp">
                                    CHAPTER III
                                </p>
                                <h3 className="roadmap__phase-title"  data-scroll data-animate="fadeIn,moveUp">
                                    Mutants Activate
                                </h3>
                                <p className="roadmap__phase-text"  data-scroll data-animate="fadeIn,moveUp">
                                    The story of BAYC isn't complete without mutants. Mutants are INSANE and get their own NFT and book - try not to drop any mayo on it.
                                </p>
                            </div>
                            {/* <!-- END Text & Title --> */}

                        </div>
                        {/* <!-- END Phase 4 --> */}

                    </div>
                </div>
            </section>
            {/* <!-- END Road Map --> */}

            {/* <!-- Team --> */}
            <section id="team" className="team">

                <div className="container-np">
                    <div className="contact-us__wrp">

                        {/* <!-- Title --> */}
                        <h2 className="roadmap__title" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '0ms' }}><span>The</span> Squad</h2>
                        {/* <!-- Title -->

                        <!-- Persones --> */}

                        <div className="persones">
                            <span className="persones__option">
                                <a href="https://twitter.com/chintu30" className="persones__twitter" target="_blank">
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '0ms' }}>
                                        @Speedracer
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '0ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic1} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '50ms' }} />
                                <p className="persones__text"  data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '50ms' }}>Contrarian and Conformist. Picked the blue pill. Now BUIDL'ing.</p>
                            </span>
                            <span className="persones__option">
                                <a href="https://twitter.com/rtan312" className="persones__twitter" target="_blank"> 
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>
                                        @RTAN
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic2} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '150ms' }} />
                                <p className="persones__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '150ms' }}>Web3 Maxi. Researching Blockchains and Writing Dapps.</p>
                            </span>
                            <span className="persones__option">
                                <a href="https://twitter.com/12GLepage" className="persones__twitter" target="_blank">
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '200ms' }}>
                                        @12GAUGE
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '200ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic3} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '250ms' }} />
                                <p className="persones__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '250ms' }}>Former videographer. Swapped the camera for a cowboy hat, giddy up.</p>
                            </span>
                            <span className="persones__option">
                                <a href="https://twitter.com/BrazyNFT" className="persones__twitter" target="_blank">
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '300ms' }}>
                                        @BRAZY
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '300ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic4} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '350ms' }} />
                                <p className="persones__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '350ms' }}>Brand & design sommelier. Pixel pushing into the real world.</p>
                            </span>
                            <span className="persones__option">
                                <a href="https://twitter.com/atareh" className="persones__twitter" target="_blank">
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '400ms' }}>
                                        @ATAREH
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '400ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic5} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '450ms' }} />
                                <p className="persones__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '450ms' }}>Writer. Degen. Good with words.</p>
                            </span>
                            <span className="persones__option">
                                <a href="https://twitter.com/MooreCarly" className="persones__twitter" target="_blank">
                                    <p className="nickname" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '400ms' }}>
                                        @CARLY
                                    </p>
                                    <img src={iconTwitter} alt="twitter" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '400ms' }} />
                                </a>
                                <img fill="#ffffff" src={apePic6} alt="Ape" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '450ms' }} />
                                <p className="persones__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '450ms' }}>Bringing the best talent to Web3. Collected books before NFTs.</p>
                            </span>

                        </div>
                        {/* <!-- Persones --> */}

                    </div>
                </div>
            </section>
            {/* <!-- END Team --> */}
            {/* <!-- Epilogue --> */}
            <section className="epilogue">
                <div className="container-np">
                    <div className="epilogue__wrp">

                        {/* <!-- Title & Text --> */}
                        <h2 className="epilogue__title" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '0ms' }}>Epilogue</h2>
                        <h3 className="epilogue__title-2" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}><span>Special Thanks to</span></h3>
                        <p className="epilogue__text"  data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '200ms' }}>TheSandbox / Lucky1s / Freecard / AndrewRosener / PaperD / Carly / KThings / ApeFather / BoredSpaceApe / Nostro / Dotty / Fvckrender / Mr312 / Cryptobeaver / Gerry / TravisNagle / Lambo / Boredape1234 / LolTapes / Ben / Asherah / Feld / BoredGentleman / Bahbs / DillyDilly / CameronMoulene / SnazzySnazz / Goodmontheth / Friesframe / CapetainTrippy / OGDfarmer / Herb / CannaCryptoPope / SmokeThatDank / StevenSchill / CryptoPainter / Insight / BoredApe1000 / TurksTokens / Ridnickulous / Lvcas / Dadjudicator / LabMax / TheFrenchie / Pharmanimal / SmarmyBum / Krunch / BoardApes / AdamHollander / Zeneca / ColinLieb / AndyGrossberg / Snuggs / MochiBones / ProfFredrick / OneBoredApe / BoredApe4662 / ClyndonSmith / Bassen / WillyTheDegen / JFC5102 / Just1n / SgSaltySoldier / FreekyCrypto / Viggy0 / Kaiju The Ape / Ridge / RDL / PPMan / Parinheidari / DimSumMaxi / Airicly / Ramongovea / Nickjames2021 / BoredBecky / Bark / Burble / ImSony / StonedBrody / TopshopBouncer / Btow806 / KeepFishin / DookieKong / SaintBayview / Lowbellie / WoundedPixel / JBandwagon / SwoleLuksoBags / TropoFarmer / Farah / Cryptoisnice / MadeOfApe / TimpersHD / coinchrist / Allo / Beijingdou / Mattborchert / FeelingFluffy / Boredape3433 / Franklin / RichieJonMason / The Monarch / Reaper / Cclccl4461 / Ckinhu1 / Leoloom / PSkan / Mikewunyc / CosmoJiang / BTCBryant / Drebin / Episom3 / BenJammin / Ape6743 / NiftyCastle / ZombieApeRich / Darthjotaro / RatKing / AstroApe / BoredCaviar / CarsonTurner / Tfarr / LindseyByrnes / VirtualToast / DocDelta / BAYC7300 / Tyler / Dragonseller / OGape5218 / AGO0314 / Filip / TotheMoonFromSG / MachiaVillain / ApeMile / SecureTheDub / TheMiamiApe / GaryGeck / 0xtsider / LikKeeRichie / Qjawe / BoredElonMusk / JeffNicholas / MrMetaMask / TyroneJkd / ThomasHu / RDM / Luxytc / SevenSeason / TravelinTweetter / CollieBuddz / StevenGalanis / SlamdiegoZoo / CrystalHefner / Aleksey / WhyNotMe / Kelly</p>
                        {/* <!-- Title & Text --> */}

                    </div>
                </div>
            </section>
            {/* <!-- Footer --> */}
            <footer className="footer">
                <div className="container-np">
                    <div className="footer__wrp">

                        {/* <!-- Police --> */}
                        <div className="footer__text-wrp">
                            <p className="footer__title" data-scroll data-animate="fadeIn,moveUp">FOREVER APES</p>
                            <p className="footer__text" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>Terms & Conditions   
                                </p>
                        </div>
                        {/* <!-- END Police --> */}

                        {/* <!-- Social --> */}
                        <div className="footer__social-wrp">
                            <a href="https://twitter.com/ForeverApesNFT" target="_blank" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>
                                <img src={iconTwitterBrown} alt="Twitter"></img>
                            </a>
                            <a href="https://opensea.io/collection/foreverapesrise" target="_blank" title="Coming Soon" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>
                                <img src={iconOpenSea} alt="Opensea"></img>
                            </a>
                            <a href="https://www.instagram.com/foreverapesnft/" target="_blank" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>
                                <img src={iconInstagram} alt="Instagram"></img>
                            </a>
                            <a href="https://discord.gg/D858MnqTay" target="_blank" data-scroll data-animate="fadeIn,moveUp" style={{ 'animationDelay': '100ms' }}>
                                <img src={iconDiscord} alt="Discord"></img>
                            </a>
                        </div>
                        {/* <!-- END Social --> */}

                    </div>
                </div>
            </footer>

        </div>

    )

}


export default Home